module.exports = __webpack_public_path__ + "media/images/ilustrations/ilustration-2-4fdaf13214a779f84160af048ca4acd2.png";